import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/** Platform routes are super_admin only — tenant Admins must not see this UI. */
const SuperAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { token, role } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  if (String(role || '').toLowerCase() !== 'super_admin') {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default SuperAdminRoute;
